import { TmapApp } from '@tmap-web-lib/tmap-app-interface'
import { useEffect, useMemo, useRef } from 'react'
import { coerce, gte } from 'semver'

import { sendEventLog } from '@/features/log/log.fn'
import MyLogDefinition from '@/features/log/log.my'
import { useOpenService } from '@/hooks'

import * as styles from './cavatarBanner.css'

interface CavatarBannerData {
  AOS: string
  iOS: string
  text: string
}

interface Props {
  data?: CavatarBannerData | null
}

const CAVATAR_DEEPLINK = 'tmap://vertical?service=cavatar&extra=%7B%22logbox%22%3A%7B%22referrer%22%3A%22my%22%7D%7D'

const GIF_URL = `${process.env.NEXT_PUBLIC_FONT_CDN}/common/gif/banner/banner_small.gif`

export function CavatarBanner({ data }: Props) {
  const openService = useOpenService()
  const { action_id, page_id } = MyLogDefinition.my
  const viewLogSent = useRef(false)

  const isVisible = useMemo(() => {
    if (!data) return false
    const osKey = TmapApp.env.isAndroid ? 'AOS' : 'iOS'
    const minVersion = coerce(data[osKey])?.version
    const appVersion = coerce(TmapApp.env.appVersion)?.version
    if (!minVersion || !appVersion) return false
    return gte(appVersion, minVersion)
  }, [data])

  useEffect(() => {
    if (!isVisible || viewLogSent.current) return
    viewLogSent.current = true
    sendEventLog(action_id?.viewCavatarStore, '', page_id)
  }, [isVisible, action_id?.viewCavatarStore, page_id])

  if (!isVisible || !data?.text) return null

  return (
    <div className={styles.wrapper}>
      <button
        type="button"
        className={styles.banner}
        onClick={() => {
          sendEventLog(action_id?.tapCavatarStore, '', page_id)
          openService(CAVATAR_DEEPLINK)
        }}
      >
        <div className={styles.content}>
          <span className={styles.title}>{data?.text}</span>
          <img className={styles.gif} src={GIF_URL} alt="" />
        </div>
      </button>
    </div>
  )
}
